/**
 * Hero Arsenal — bottom navigation scroll affordance.
 * Adds a class to the nav when it can scroll further right/left,
 * so you can optionally style fade edges in CSS if desired.
 */
(function () {
  var navs = document.querySelectorAll('.hero-arsenal__nav-scroll');

  navs.forEach(function (nav) {
    function updateScrollState() {
      var maxScroll = nav.scrollWidth - nav.clientWidth;
      nav.classList.toggle('is-scrolled-start', nav.scrollLeft <= 0);
      nav.classList.toggle('is-scrolled-end', nav.scrollLeft >= maxScroll - 1);
    }

    updateScrollState();
    nav.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);
  });
})();